<template>
  <div id="app">
    <router-view></router-view>
    <!-- <Scores v-bind:date="currentDate" /> -->
  </div>
</template>

<script>
// import Header from './components/Header.vue'
// import Scores from './components/Scores.vue'

export default {
  name: 'App',
  currentDate: '2019-08-10',
  components: {
    // Header,
    // Scores
  },
  methods: {
    dateChange(date) {
      this.currentDate = date;
    }
  }, 
  data() {
    return {
      currentDate: this.currentDate
    };
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

img {
  width: 20vw;
}
</style>
